import { h, Component } from 'preact';
import {Form, FormEntry, Button, I18n} from 'components/elements'
import {connect} from 'react-redux'
import style from './index.less'
import {AccountActions, PageActions} from 'actions'
import store from 'reducers'

@Form
@connect((state)=> state)
export default class Login extends Component {
    constructor(props, context){
        super(props, context)
        this.state = {
            passwordError: false,
            accountLocked: false,
            emailError: false,
            value: ''
        }

        this.handleLogin = this.handleLogin.bind(this)
        this.handleChange = this.handleChange.bind(this)
    }

    handleLogin(data){
        data.value = this.state.value
        AccountActions.authenticate(data).then((response)=>{
            PageActions.reset()
        })
        .catch((e)=>{
            if(String(Object(e.response.data).error).includes("is currently locked, come back later and try again.")){
                this.setState({
                    accountLocked: true,
                    passwordError: false
                })
            } else {
                this.setState({
                    passwordError: true
                })
            }
        })
    }
    handleChange(e){

        if(this.state.passwordError){
            this.setState({
                passwordError: false
            })
        }
        if(e.target.name == 'value'){
            this.setState({
                value: e.target.value,
                emailError: false
            })
        }
    }
    render(){
        const {Input, Form} = this.props
        return (
            <Form class={style.login} onSubmit={this.handleLogin}>
                <strong>
                    <I18n>loginforeasieraccess</I18n>
                </strong>
                <br />
                <br />
                <Input onChange={this.handleChange} required={true} name='value' question={I18n.t('emailOrPhone')} type='text' types={['email', 'phone']} />
                <br />
                <Input onChange={this.handleChange} required={true} name='password' question={I18n.t('password')} type='password' />
                <br />
                <div class={style.resetPassword} onClick={this.props.handlePasswordResetPrompt}><I18n>resetPassword</I18n></div>
                <div class={style.errorSpacing}>
                    {this.state.accountLocked && 
                        <div class={style.errorMessage}>This account is currently locked due to too many failed attempts, please try again in 30 minutes.</div>
                    }
                    {this.state.passwordError && 
                        <div class={style.errorMessage}>The password or email/phone number entered is incorrect.</div>
                    }
                    {this.state.emailError && 
                        <div class={style.errorMessage}>Please enter an email or mobile phone number.</div>
                    }
                </div>
                <Button><I18n>login</I18n></Button>
            </Form>
        )
    }
}


// WEBPACK FOOTER //
// ./components/partials/Login/index.js